//     							                          //
//  Program: LeasingSidebar.jsx                           //
//  Application: Property                                 //
//  Option: common component Leasing Sidebar              //
//  Developer: NP 		                                  //
//  Date: 2022-04-02                                      //
//                                                        //
////////////////////////////////////////////////////////////

import React, { Component } from "react";
import { Link } from "react-router-dom";
// import { Dropdown } from 'react-bootstrap';
class AllPropertyLeasingSidebar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pathname: window.location.pathname,
      property_slug: sessionStorage.getItem("property_slug")
        ? sessionStorage.getItem("property_slug")
        : "",
    };
  }

  isPathActive(path) {
    return window.location.pathname.includes(path);
  }

  toggleHeaderMenu(e) {
    e.preventDefault();
    const data = document.querySelector(".col-md-2");
    if (data != null) {
      if (data.classList.contains("hide")) {
        data.classList.replace("hide", "left");
        document.querySelector("body").classList.toggle("az-header-menu-show");
        document.querySelector(".mobchildMenu").classList.remove("d-none");
        document.querySelector(".newSubmenu").classList.remove("d-none");
      } else {
        data.classList.replace("left", "hide");
        document.querySelector("body").classList.toggle("az-header-menu-show");
        document.querySelector(".mobchildMenu").classList.add("d-none");
        document.querySelector(".newSubmenu").classList.add("d-none");
      }
    }
  }

  toggleChildMenu(e) {
    e.preventDefault();
    document.querySelector(".mobchildMenu").classList.toggle("d-none");
    document.querySelector(".newSubmenu").classList.toggle("d-none");
    const data = document.querySelector(".col-md-2");
    if (data != null) {
      if (data.classList.contains("hide")) {
        data.classList.replace("hide", "left");
      } else {
        data.classList.replace("left", "hide");
      }
    }
  }

  render() {
    return (
      <>
        <div className="deskchildMenu">
          <div
            className="backtosubMenu"
            onClick={(event) => this.toggleChildMenu(event)}
          >
            <i className="fas fa-chevron-left"></i>Back to Leasing
          </div>
          <aside>
            <nav className="nav nav-pills flex-column pd-r-8">
              <ul>
                <li>
                  <span>Leasing</span>
                  <ul>
                    {global.userPermissions.checkPermission(
                      "lease-calendar-list"
                    ) && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("lease-avail-calendar")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={"/global-lease-avail-calendar"
                          }
                        >
                          Calendar
                        </Link>
                      </li>
                    )}
                    {global.userPermissions.checkPermission(
                      "availability-list"
                    ) && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("availability")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={"/availability"
                          }
                        >
                          Availability
                        </Link>
                      </li>
                    )}
                    {global.userPermissions.checkPermission("leases-list") && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("leasing")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={"/leasing"
                          }
                        >
                          Leases
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
                <li>
                  <span>Applications</span>
                  <ul>
                    {global.userPermissions.checkPermission(
                      "applicants-list"
                    ) && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("applicants")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={"/applicants"
                          }
                        >
                          Applicants
                        </Link>
                      </li>
                    )}
                    {global.userPermissions.checkPermission("inquiry-list") && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("applicant-detail")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={"/applicant-detail"
                          }
                        >
                          Inquiry
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
                <li>
                  <span>Residents</span>
                  <ul>
                    {global.userPermissions.checkPermission(
                      "residents-list"
                    ) && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("residents")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={"/residents"
                          }
                        >
                          Residents
                        </Link>
                      </li>
                    )}
                    {/* {global.userPermissions.checkPermission("rent-list") && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("rent")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={"/rent"
                          }
                        >
                          Rent
                        </Link>
                      </li>
                    )} */}
                    {/* {global.userPermissions.checkPermission("payout-list") && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("resident-payouts")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={"/resident-payouts"
                          }
                        >
                          Payouts
                        </Link>
                      </li>
                    )}   */}
                  </ul>
                </li>
              </ul>
            </nav>
          </aside>
        </div>
        <div className="mobchildMenu">
          <div className="d-flex justify-content-between align-items-center submenu">
            {/* New submenu */}
            <div className="newSubmenu">
              <span
                className="back"
                onClick={(event) => this.toggleHeaderMenu(event)}
              >
                <i className="fas fa-chevron-left"></i> Back to Leasing
              </span>
              <ul>
                <li>
                  <ul>
                    {global.userPermissions.checkPermission(
                      "lease-calendar-list"
                    ) && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("lease-avail-calendar")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={"/global-lease-avail-calendar"
                          }
                        >
                          Calendar
                        </Link>
                      </li>
                    )}
                    {global.userPermissions.checkPermission(
                      "availability-list"
                    ) && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("availability")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={"/availability"
                          }
                        >
                          Availability
                        </Link>
                      </li>
                    )}
                    {global.userPermissions.checkPermission("leases-list") && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("leasing")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={"/leasing"
                          }
                        >
                          Leases
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
                <li>
                  <span>Applications</span>
                  <ul>
                    {global.userPermissions.checkPermission(
                      "applicants-list"
                    ) && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("applicants")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={"/applicants"
                          }
                        >
                          Applicants
                        </Link>
                      </li>
                    )}
                    {global.userPermissions.checkPermission("inquiry-list") && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("applicant-detail")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={"/applicant-detail"
                          }
                        >
                          Inquiry
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
                <li>
                  <span>Residents</span>
                  <ul>
                    {global.userPermissions.checkPermission(
                      "residents-list"
                    ) && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("residents")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={"/residents"
                          }
                        >
                          Residents
                        </Link>
                      </li>
                    )}
                    {global.userPermissions.checkPermission("rent-list") && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("rent")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={"/rent"
                          }
                        >
                          Rent
                        </Link>
                      </li>
                    )}
                    {/* {global.userPermissions.checkPermission("payout-list") && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("resident-payouts")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={"/resident-payouts"
                          }
                        >
                          Payouts
                        </Link>
                      </li>
                    )} */}
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default AllPropertyLeasingSidebar;
